interface ISiteElementCheckItem {
    addValue(value: ISiteFilterItemValue): void;
    removeValue(value: ISiteFilterItemValue): void;
    containsValue(value: ISiteFilterItemValue): boolean;
}

class SiteElementCheckColorItem
    extends QueryElement<HTMLElement> {

    private readonly _filter: ISiteElementCheckItem;
    private readonly _value: ISiteFilterColorItemValue;
    
    constructor(
        filter: ISiteElementCheckItem, 
        value: ISiteFilterColorItemValue) {
        
        super(document.createElement("A"));

        this._filter = filter;
        this._value = value;
        
        this.addClass("element-filter-checkitem");

        // Create a div container for color, title, and count
        let container = QueryElement.QueryElement("DIV")
            .addClass("colorItemContainer");

        // Create color span
        let color = QueryElement.QueryElement("SPAN")
            .addClass("colorContainer");

        const style = this.style();
        if (style && this._value.colorName) {
            style.setProperty('--item-backgroundcolor', this._value.colorName);
            switch(this._value.colorName)
            {
                default: 
                    style.setProperty('--item-color', "#FFFFFF");
                    break;
                case "white":
                    style.setProperty('--item-color', "#000000");
                    break;
                case "yellow":
                    style.setProperty('--item-color', "#000000");
                    break;

            }
        }

        // Set the background color
        if (value.colorName) {
            const style = color.style();
            if (style) {
                style.backgroundColor = value.colorName; 
            }
        }

        container.append(color);  // Add color span to container
        
        let title = QueryElement.QueryElement("SPAN")
            .addClass("title")
            .setText(value.name);

        container.append(title);
        
        if (value.count != null) {
            let count = QueryElement.QueryElement("SPAN")
                .addClass("count")
        
            count.setText(value.count.toString());
            
            container.append(count);  // Add count to container
        }

        // Append the container to the element
        this.append(container);
        
        // Check if this filter item is active
        if (filter.containsValue(value)) {
            this.makeActive();
        }
        this.on("click", e => {
            this.click();
        });
    }

    click() {
        if (this.isActive()) {
            this._filter.removeValue(this._value);
            this.makeInactive();
        } else {
            this._filter.addValue(this._value);
            this.makeActive();
        }
    }
    makeActive() {
        this.addClass("active");
    }
    makeInactive() {
        this.removeClass("active");
    }
    isActive() {
        return this.containsClass("active");
    }
}